import { useRef, useState } from 'react';
import Slider from 'react-slick';
//==========import icons =================
import { MdLocationOn } from 'react-icons/md';
import { HiOutlineArrowLeft, HiOutlineArrowRight } from 'react-icons/hi';
import { AiFillCaretRight, AiFillRightCircle } from 'react-icons/ai';

//==============import components=================
import TitleSection from 'components/common/TitleSection';
import { servicesCarouselData } from 'helpers/homeHelper';

const ServicesCarousel = () => {
  const [tab, setTab] = useState('corporative');
  const customeSlider = useRef();
  const titleDetail = {
    upperTitle: '',
    middleTitle: 'dE EVENTE PARTNERS',
    lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
  };
  let settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 500,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const gotoNext = () => {
    customeSlider.current.slickNext();
  };

  const gotoPrev = () => {
    customeSlider.current.slickPrev();
  };
  return (
    <section className='serviceCarouselSec DBlock py-10 sm:py-12 px-6 sm:px-10 bg-eventLightPink'>
      <div className='max-w-7xl mx-auto'>
        <TitleSection titleDetail={titleDetail} />
        <div className='DBlock relative xl:pb-6'>
          <div className='flex items-center justify-end gap-4 text-xl md:text-3xl text-eventGray font-bold mb-4'>
            <HiOutlineArrowLeft className='cursor-pointer' onClick={gotoPrev} />
            <HiOutlineArrowRight
              className='cursor-pointer'
              onClick={gotoNext}
            />
          </div>
          <ul className='text-eventGray text-sm capitalize font-medium'>
            {['customize', 'corporative', 'entertairment', 'private'].map(
              (list) => (
                <li
                  key={`listId${list}`}
                  onClick={() => setTab(list)}
                  className={`relative ${
                    list === tab
                      ? 'text-eventDarkYellow font-semibold'
                      : 'text-eventGray'
                  }`}>
                  {list === tab && (
                    <span className='absolute bottom-6 left-4 rotate-180'>
                      <AiFillCaretRight size={30} color='#986C19' />
                    </span>
                  )}
                  {list}
                </li>
              )
            )}
          </ul>
          <Slider
            {...settings}
            ref={customeSlider}
            className='max-w-6xl mx-auto'>
            {servicesCarouselData?.map((list) => (
              <div key={`carouselKey${list?.id}`} className='px-2 '>
                <div className='p-2 bg-white rounded-2xl shadow-sm outline-none border-none'>
                  <div className='relative'>
                    <img
                      className='rounded-md shadow-sm w-full object-cover'
                      src={list?.image}
                      alt='cardImg'
                    />
                    <AiFillRightCircle
                      className='absolute -bottom-3 right-3 cursor-pointer bg-white rounded-full'
                      stroke='white'
                      color='#DCB365'
                      size={30}
                    />
                  </div>
                  <h3 className='font-bold text-base md:text-lg tracking-widest p-2 capitalize'>
                    {list?.event}
                  </h3>
                  <div className='flex items-center justify-between px-2 pb-4 text-base text-eventGray'>
                    <p className='flex items-center text-base md:text-lg font-medium'>
                      <span>
                        <MdLocationOn fill='#FF6647' size={20} />
                      </span>
                      {list?.location}
                    </p>
                    <p>{list?.date}</p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default ServicesCarousel;
